module.exports = __webpack_public_path__ + "img/张店乡.641f3cf2.png";